import { Log, apiRequest } from '@ext/utils';
import { Paginacion } from '@ext/env';
import * as Pedidos from '../';
import { IResumenPedidos } from './Resumen.lib';
import moment from 'moment';

export class ResumenPedidos extends IResumenPedidos
{

    public static async create( tipo: string = null): Promise<ResumenPedidos>
    {
        let o = new ResumenPedidos();
        o.Tipo = tipo;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/pedidos/estadistica';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        if ( this.Tipo )
            request.params.tipo = this.Tipo;
        request.path = `${this.Route}`;

        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }


}
